import React from "react";
import _ from "lodash";
import { FormatMessage } from "react-globalize";
import { Link } from "react-router";

export interface ICatalog {
    title: string;
    _link: string;
}

/**
 * Composes message with formatted summary of bulk entries add
 *
 * @method getCatalogErrorMessage
 * @param {object} catalog - Catalog object
 * @param {object} rejectedEntriesGroupedByCause - Catalog object
 * @param {Array<object>} rejectedEntriesGroupedByCause.warehouse - rejected item
 * @param {Array<object>} rejectedEntriesGroupedByCause.unspecified - rejected item
 * @returns {JSX.Element} - react element containing message and link to linesheet
 */
export const getCatalogErrorMessage = (
    catalog: ICatalog,
    rejectedEntriesGroupedByCause: { warehouse?: any[]; unspecified?: any[] }
) => {
    let amount: number = 0;
    let errorMessage = "Oops! Something went wrong. Please refresh and try again.";

    if (_.size(rejectedEntriesGroupedByCause?.warehouse)) {
        amount = _.size(rejectedEntriesGroupedByCause.warehouse);
        errorMessage =
            "|amount| product(s) could not be added because they are not available in |catalogName|'s selected warehouse";
    }

    return (
        <span>
            <FormatMessage
                path={errorMessage}
                variables={{ amount, catalogName: catalog.title }}
                elements={{ link: <Link to={catalog._link} /> }}
            />
        </span>
    );
};

/**
 * Composes message with formatted summary of bulk entries add
 * @param {object} catalog - Catalog object
 * @param {Array<object>} [data.createdEntries] - Created entries
 * @param {Array<object>} [data.rejectedEntries] - Rejected entries
 * @returns {JSX.Element} - react element containing message and link to linesheet
 */
export const getCatalogSummaryMessage = (
    catalog: ICatalog,
    data: { createdEntries?: any[]; rejectedEntries?: any[] }
) => {
    const { createdEntries, rejectedEntries } = data;
    const totalAdded = _.size(createdEntries);
    const totalRejected = _.size(rejectedEntries);
    const fullAmount = totalAdded + totalRejected;
    let amount: number;
    let message: string;
    if (totalAdded === fullAmount) {
        message = "|amount| product(s) added to |catalogName|.";
        amount = totalAdded;
    } else if (totalRejected === fullAmount) {
        message =
            "|amount| product(s) could not be added because they are not available in |catalogName|'s selected warehouse";
        amount = totalRejected;
    } else {
        message =
            "|amount| of |fullAmount| product(s) could not be added because they are not in |catalogName|'s selected warehouse.";
        amount = totalRejected;
    }
    return (
        <span>
            <FormatMessage
                path={message}
                variables={{ amount, fullAmount, catalogName: catalog.title }}
                elements={{ link: <Link to={catalog._link} /> }}
            />
        </span>
    );
};
